import { Trans } from '@lingui/react';
import * as React from 'react';
import { Badge } from '../Badge';
import { Clickable } from '../Clickable';
import { Icon } from '../Icon';
import useStyles from './NavItem.styles';
import clsx from 'clsx';

export interface INavItemProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  subtitle: React.ReactNode;
  status?: 'enabled' | 'disabled';
  onClick?(): void;
  canNavigate?: boolean;
}

const NavItem: React.FC<INavItemProps> = ({
  icon,
  title,
  status,
  subtitle,
  onClick,
  canNavigate = true,
}) => {
  const classes = useStyles();

  return (
    <Clickable
      className={
        canNavigate ? classes.root : clsx(classes.root, classes.rootDisabled)
      }
      onClick={onClick}
    >
      <div className={classes.icon}>{icon}</div>
      <div className={classes.body}>
        <div className={classes.title}>
          {title}
          {status && (
            <div className={classes.badge}>
              {status === 'enabled' ? (
                <Badge type="success">
                  <Trans id="Enabled" />
                </Badge>
              ) : status === 'disabled' ? (
                <Badge type="error">
                  <Trans id="Disabled" />
                </Badge>
              ) : null}
            </div>
          )}
        </div>
        <div className={classes.subtitle}>{subtitle}</div>
      </div>
      {onClick && canNavigate && (
        <div className={classes.chevron}>
          <Icon type="chevronRight" />
        </div>
      )}
    </Clickable>
  );
};

export default NavItem;
